export default __webpack_public_path__ + "assets/itulab-component.99800d3e.svg";